import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { UserService } from '../../user/services/user.service';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { Util } from '../../../utils/util';
import { ShopService } from '../../shop/service/shop.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { BadgeModule } from 'primeng/badge';
import { DividerModule } from 'primeng/divider';
import { PickListModule } from 'primeng/picklist';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ListboxModule } from 'primeng/listbox';


import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { Constants } from '../../../utils/Constants';
@Component({
  selector: 'app-users',
  standalone: true,
  imports: [
    CommonModule,
    InputTextModule,
    CardModule,
    Tabs, TabList, Tab, TabPanels, TabPanel,
    TableModule,
    TagModule,
    TranslateModule,
    /*  RolePermissionComponent, */
    IconFieldModule,
    InputIconModule,
    ButtonModule,
    SelectModule,
    BadgeModule,
    DividerModule,
    DialogModule,
    PickListModule,
    ToastModule,
    ListboxModule,
    FormsModule,
    NgxPermissionsModule,
  ],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
  providers: [DialogService, MessageService],
})
export class UsersComponent implements OnInit {
  users = [];
  selectedUsers = [];
  constUsers = [];
  roles: any[] = [];
  sellerRoles: any[] = [];
  operatorRoles: any[] = [];
  loading = false;
  rows = 100;
  user;
  headers = [
    { field: 'firstname', header: 'table.user' },
    { field: 'email', header: 'Email' },
    {
      field: 'relatedRoles',
      header: 'table.roles',
      type: 'list',
      listField: 'roleName',
      sort: false,
    },
    { field: 'active', header: 'table.accountStatus', type: 'tag' },
    {
      field: 'relatedShops',
      header: 'table.shops',
      type: 'list',
      listField: 'shopName',
      sort: false,
    },
    {
      field: 'channel',
      header: 'table.canal',
      hidden: this.userService.isSeller(),
      sort: false,
    },
    {
      field: 'creationDate',
      header: 'table.creationDate',
      sortField: 'creationtime',
    },
    { field: 'lastConnectionDate', header: 'table.lastConnectionDate' },
  ];
  editRoleDialogVisible = false;
  activeIndex: number = 0;
  affectedRoles = [];
  availableRoles = [];
  rolesToAdd = [];
  rolesToRemove = [];
  searchData: any = {
    shopCode: null,
    searchKeyWord: '',
    offset: 0,
    itemSize: this.rows,
    status: null,
    orderColumn: null,
    orderDirection: null,
    lastConnectionDateStart: null,
    lastConnectionDateEnd: null,
    isOperator: false,
  };
  totalRecords;
  filters;
  appliedFilters = {};
  tags = [];
  searchFilters = {};
  ref: DynamicDialogRef | undefined;
  selectAll = false;
  shops;
  onlyOperatorsSelected = false;
  onlySellerSelected = false;
  availableShops = [];
  availableShopsDupes = [];
  affectedShops = [];
  shopsToRemove = [];
  shopsToAdd = [];
  hasNext: boolean;

  selectedItems!: any[];
  constants = Constants;
  disabledExportButton = false;

  @ViewChild(Table) table: Table;
  
  constructor(
    private readonly translate: TranslateService,
    private readonly userService: UserService,
    private readonly shopService: ShopService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly dialogService: DialogService,
    private readonly messageService: MessageService,
    private readonly permissionService: NgxPermissionsService,
  ) {}
  
  ngOnInit() {
    this.user = this.userService.getUser();
    this.selectedUsers = [];
    
    this.loadRoles();
    this.getShops();
    this.setupTabFromRouteParams();
    if(this.user.operator) {
      this.shopService.getPaginatedShops("", 0).subscribe({
        next: (res) => {
          this.shops = res['shops']
          this.hasNext = res['hasNext']
        }
      })
    }
    
  }

  private loadRoles() {
    if(this.user.operator) {
      this.loadOperatorRoles();
    }
    this.loadSellerRoles();
  }

  private loadOperatorRoles() {
    this.userService.getOperatorRoles().subscribe({
      next: (roles: any) => {
        this.operatorRoles = roles;
        this.getRoles();
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  private loadSellerRoles() {
    this.userService.getSellerRoles().subscribe({
      next: (roles: any) => {
        this.sellerRoles = roles;
        this.getRoles();
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  private setupTabFromRouteParams() {
    this.route.queryParams.subscribe((params) => {
      const tab = params['tab'];
      if (tab) {
        this.activeIndex = +tab; // Convert to number and set as active index
      }
    });
  }

  isOperatorAdmin() {
    return this.permissionService.getPermission(
      'PERMISSION_MANAGE_ROLES_AND_USERS',
    );
  }

  isSuperAdmin() {
    return this.permissionService.getPermission(
      'PERMISSION_SUPER_ADMIN',
    );
  }

  isSeller() {
    return this.userService.isSeller();
  }

  getRoles() {
    this.roles = this.user.operator ? this.operatorRoles : this.sellerRoles;
  }

  getShops() {
    this.shopService.getMarketplaceShops().subscribe({
      next: (shops: any) => {
        this.availableShops = shops;
        this.availableShopsDupes = [...this.availableShops];
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  applyFilter() {
    this.resetSearchDataFilters();
    this.populateSearchDataFromFilters();
  }

  private resetSearchDataFilters() {
    this.searchData['roles'] = [];
    this.searchData['status'] = [];
    this.searchData['shops'] = [];
    this.searchData['lastConnectionDateStart'] = null;
    this.searchData['lastConnectionDateEnd'] = null;
  }

  private populateSearchDataFromFilters() {
    for (let key in this.searchFilters) {
      switch (key) {
        case 'role':
          this.searchData['roles'] = this.searchFilters[key];
          break;
        case 'compte':
          this.searchData['status'] = this.searchFilters[key];
          break;
        case 'lastConnectionDate': {
          this.searchData['lastConnectionDateStart'] =
            this.searchFilters[key][0] ?? null;
          this.searchData['lastConnectionDateEnd'] =
            this.searchFilters[key][1] ?? null;
          break;
        }
        case 'shopMultipleWithShopCode':
          this.searchData['shops'] = this.searchFilters[key];
          break;
        default:
          this.searchData[key] = this.searchFilters[key];
          break;
      }
    }
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    const currentPage = event.first / event.rows;
    this.searchData.offset = currentPage;
    this.searchData.itemSize = event.rows;
    this.searchData.orderColumn = event.sortField;
    this.searchData.orderDirection = event.sortOrder === 1 ? 'ASC' : 'DESC';
    this.getUsers();
  }

  getUsers() {
    this.applyFilter();
    this.loading = true;

    let getUsersObservable: Observable<any>;
    
    if (this.userService.isSuperAdmin) {
      this.searchData.isOperator = null;
      getUsersObservable = this.userService.getUsersForSuperAdmin(this.searchData);
    } else if (this.user.operator) {
      this.searchData.isOperator = true;
      getUsersObservable = this.userService.getUsers(this.searchData);
    } else {
      this.searchData.isOperator = false;
      this.searchData.shopCode = this.user.defaultShop.shopCode;
      getUsersObservable = this.userService.getUsersOfShop(this.searchData);
    }

    getUsersObservable.subscribe({
      next: (res) => {
        this.processUsersResponse(res);
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  private processUsersResponse(res) {
    this.constUsers = structuredClone(res.content);
    this.users = res.content;
    this.totalRecords = res.totalElements;
     
    for (const user of this.users) {
      this.enhanceUserData(user);
    }
    this.loading = false;
  }

  private enhanceUserData(user) {
    user.shop = user.defaultShop?.shopName;
    user.channel = user.defaultChannel?.channelName;
    user.relatedRoles = user.relatedRoles.filter(
      (role) => role.roleCode != 'ROLE_ACCESS_APP',
    );
    return user;
  }

  removeSelection() {
    this.selectedUsers = [];
    this.selectAll = false;
  }

  onSelectionChange(event) {
    this.selectAll = false;
  }

  selectAllUsers() {
    this.selectAll = true;
    this.selectedUsers = this.users;
  }

  filterGlobal(event) {
    this.searchData.searchKeyWord = event.target.value;
    this.onLazyLoad({
      first: 0,
      rows: this.rows,
      sortField: null,
      sortOrder: null,
    });
  }

  getSeverity(status) {
    return Util.getSeverity(status);
  }

  initFilters() {
    this.filters = [];
    this.addRoleFilter();
    this.addAccountStatusFilter();
    
    if (this.userService.isOperator) {
      this.addShopFilter();
    }

    this.addLastConnectionDateFilter();
  }

  private addRoleFilter() {
    this.filters.push({
      type: 'select',
      search: false,
      name: 'role',
      key: 'roleCode',
      display: 'roleName',
      header: 'table.roles',
      values: this.roles,
    });
  }

  private addAccountStatusFilter() {
    this.filters.push({
      type: 'select',
      search: false,
      name: 'compte',
      key: 'key',
      display: 'name',
      header: 'filters.accountStatus',
      values: [
        { key: 'ACTIVE' , name: this.translate.instant('ACTIVE') },
        { key: 'NOT_ACTIVE', name: this.translate.instant('NOT_ACTIVE') },
      ],
    });
  }

  private addShopFilter() {
     this.filters.push({
        type: 'list',
        search: false,
        name: 'shopMultipleWithShopCode',
        key: 'shopCode',
        display: 'shopNameWithChannel',
        header: 'filters.shops',
        values: this.shops,
        hasNext : this.hasNext,
        selectionMode: 'multiple'
      });
  }

  private addLastConnectionDateFilter() {
    this.filters.push({
      type: 'date',
      name: 'lastConnectionDate',
      header: 'filters.lastConnectionDate',
    });
  }

  openFilterModal() {
    Util.openFilterModal(
      this.dialogService,
      this.translate,
      this,
      this.initFilters,
      this.onLazyLoad
    );
  }
  
  resetFilters() {
    Util.resetFilters(this, this.onLazyLoad);
  }

  removeFilter(val, parent) {
    const productListFilterMap = {
      'roles': 'role',
      'status': 'compte',
      'shops': 'shopMultipleWithShopCode',
      'dates': 'lastConnectionDate'
    };
    Util.removeFilter(val, parent, this, this.onLazyLoad, this.rows, productListFilterMap);
  }

  openEditRoleDialog() {
    this.resetEditRoleData();
    this.checkUserSelectionType();
    this.prepareAvailableAndAffectedItems();
    this.editRoleDialogVisible = true;
  }

  private resetEditRoleData() {
    this.rolesToAdd = [];
    this.rolesToRemove = [];
  }

  private checkUserSelectionType() {
    this.onlyOperatorsSelected = this.selectedUsers.every(
      (user) => user.operator,
    );
    this.onlySellerSelected = this.selectedUsers.every(
      (user) => !user.operator,
    );
  }

  private prepareAvailableAndAffectedItems() {
    this.prepareAffectedAndAvailableRoles();
    this.prepareAffectedAndAvailableShops();
  }

  private prepareAffectedAndAvailableRoles() {
    const affectedRolesDupes = [
      ...new Set(
        this.selectedUsers
          .flatMap((user) => user.relatedRoles)
          .filter(
            (role) => {
              const excludedRoles = ['ROLE_OPERATOR_SELLER', 'ROLE_ACCESS_APP'];
              if(!this.userService.isSuperAdmin){
                excludedRoles.push('ROLE_PRIVILEGED_ADMIN', 'ROLE_MASTER_CATALOG');
              }
              return !excludedRoles.includes(role.roleCode);
            }
          ),
      ),
    ];
    
    this.affectedRoles = Array.from(
      new Map(
        affectedRolesDupes.map((role: any) => [role.roleCode, role]),
      ).values(),
    );
    
    this.setAvailableRoles();
  }

  private setAvailableRoles() {
    if (this.onlyOperatorsSelected) {
      this.availableRoles = this.operatorRoles.filter(
        (availableRole) =>
          !this.affectedRoles.some(
            (affectedRole) => affectedRole.roleCode === availableRole.roleCode,
          ),
      );
      this.availableRoles = this.availableRoles.filter(
        (role) => {
          const excludedRoles = ['ROLE_OPERATOR_SELLER', 'ROLE_SELLER', 'ROLE_SELLER_ADMIN'];
          if (!this.userService.isSuperAdmin) {
            excludedRoles.push('ROLE_PRIVILEGED_ADMIN');
          }
          return !excludedRoles.includes(role.roleCode);
        }
      );
    } else if (this.onlySellerSelected) {
      this.availableRoles = this.sellerRoles.filter(
        (availableRole) =>
          !this.affectedRoles.some(
            (affectedRole) => affectedRole.roleCode === availableRole.roleCode,
          ),
      );
    } else {
      this.availableRoles = [];
      this.affectedRoles = [];
    }
  }

  private prepareAffectedAndAvailableShops() {
    this.availableShops = this.availableShopsDupes.filter(
      (itemA) =>
        !this.selectedUsers.some((itemB) =>
          itemB.relatedShops.some(
            (relatedShop) => relatedShop.shopCode === itemA.shopCode,
          ),
        ),
    );

    const affectedShopsDupes = [
      ...new Set(this.selectedUsers.flatMap((user) => user.relatedShops)),
    ];
    
    this.affectedShops = Array.from(
      new Map(
        affectedShopsDupes.map((shop: any) => [shop.shopCode, shop]),
      ).values(),
    );
  }

  onTabChange(value: any) {
    const tabIndex = typeof value === 'number' ? value : value?.index;
    this.activeIndex = tabIndex ?? 0;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: tabIndex },
      queryParamsHandling: 'merge',
    });
  }

  affectRoles() {
    const data = this.prepareRolesData();
    const opData = this.prepareOperatorShopsData();
    
    this.userService.asscoiateRolesToSellers(data).subscribe({
      next: () => {
        this.editRoleDialogVisible = false;
        if (this.onlyOperatorsSelected) {
          this.assignShopsToOperators(opData);
        } else {
          this.showSuccessMessageAndRefresh();
        }
      },
      error: (error) => {
        this.showErrorMessage();
        console.error(error);
      },
    });
  }

  private prepareRolesData() {
    let emails = null;
    let userFilters = null;
    
    if (this.selectAll) {
      userFilters = this.appliedFilters;
      if (this.userService.isSeller()) {
        userFilters['shops'] = [this.shopService.getSelectedShop().shopCode];
      }
    } else {
      emails = this.selectedUsers.map((user) => user.email);
    }

    return {
      emails: emails,
      rolesToAdd: this.rolesToAdd.map((role) => role.roleCode),
      rolesToRemove: this.rolesToRemove.map((role) => role.roleCode),
      userFilters: userFilters,
    };
  }

  private prepareOperatorShopsData() {
    let emails = null;
    let userFilters = null;
    
    if (this.selectAll) {
      userFilters = this.appliedFilters;
      if (this.userService.isSeller()) {
        userFilters['shops'] = [this.shopService.getSelectedShop().shopCode];
      }
    } else {
      emails = this.selectedUsers.map((user) => user.email);
    }

    return {
      emails: emails,
      userFilters: userFilters,
      shopsToAdd: this.shopsToAdd.map((item) => item.shopCode),
      shopsToRemove: this.shopsToRemove.map((item) => item.shopCode),
    };
  }

  assignShopsToOperators(data: any) {
    this.userService.asscoiateShopsToOperators(data).subscribe({
      next: () => {
        this.selectedItems = [];
        this.showSuccessMessageAndRefresh();
      },
      error: (error) => {
        this.selectedItems = [];
        this.showErrorMessage();
        console.error(error);
      },
    });
  }

  private showSuccessMessageAndRefresh() {
    this.messageService.add({
      severity: 'success',
      summary: this.translate.instant('messages.success'),
      detail: this.translate.instant('messages.saveSuccess'),
    });
    this.selectedUsers = [];
    this.getUsers();
  }

  private showErrorMessage() {
    Util.showErrorMessage(this.messageService, this.translate)
  }

  addRole(event) {
    const roles = event.items;
    this.rolesToRemove = this.removeItemsFromArray(this.rolesToRemove, roles);
    this.rolesToAdd = this.rolesToAdd.concat(roles);
  }

  removeRole(event) {
    const roles = event.items;
    this.rolesToAdd = this.removeItemsFromArray(this.rolesToAdd, roles);
    this.rolesToRemove = this.rolesToRemove.concat(roles);
  }

  addShop(event) {
    const shops = event.items;
    this.shopsToRemove = this.removeItemsFromArray(this.shopsToRemove, shops);
    this.shopsToAdd = this.shopsToAdd.concat(shops);
  }

  removeShop(event) {
    const shops = event.items;
    this.shopsToAdd = this.removeItemsFromArray(this.shopsToAdd, shops);
    this.shopsToRemove = this.shopsToRemove.concat(shops);
  }

  private removeItemsFromArray(array, itemsToRemove) {
    return array.filter((item) => !itemsToRemove.includes(item));
  }

  exportUsers() {
    const data = this.prepareExportData();
    let exportObservable: Observable<any>;
    this.disabledExportButton = true;
    
    if (this.userService.isSuperAdmin) {
      exportObservable = this.userService.exportUsersForAdminToExcel(data);
    } else if (this.user.operator) {
      exportObservable = this.userService.exportUsersForOperatorToExcel(data);
    } else {
      exportObservable = this.userService.exportUsersForSellerToExcel(data);
    }
    
    this.handleExportUsers(exportObservable);
  }

  private prepareExportData() {
    return {
      filter: this.searchData,
      userEmails: this.selectAll
        ? []
        : this.selectedUsers.map((user) => user.email),
      all: this.selectAll,
    };
  }

  private handleExportUsers(request$: Observable<any>) {
    request$.subscribe({
      next: (response) => {
        this.disabledExportButton = false;
        Util.handleExportSuccess(response)
      },
      error: Util.handleExportError,
    });
  }
}
